"use client";

import { type ReactNode } from "react";

import { AppDialogProvider } from "@/components/dialogs/app-dialog-provider";

import { QueryProvider } from "./query-provider";
import { ThemePreferencesSync } from "./theme-preferences-sync";
import { ThemeProvider } from "./theme-provider";

type AppProvidersProps = {
  children: ReactNode;
};

/** Framer Motion remains available for specific components (e.g. modal); keep root lean for perf. */
export function AppProviders({ children }: AppProvidersProps) {
  return (
    <QueryProvider>
      <ThemeProvider>
        <ThemePreferencesSync />
        <AppDialogProvider>{children}</AppDialogProvider>
      </ThemeProvider>
    </QueryProvider>
  );
}
